export default __webpack_public_path__ + "static/media/fondo2.ded20f0a.png";